import { View, Platform } from 'react-native';
import { StyleSheet } from 'react-native';

// Custom dashed line for web
const Dash = () => (
    <View style={styles.dash} />
);

const styles = StyleSheet.create({
    dash: {
        borderBottomWidth: 1,
        borderColor: 'black',
        borderStyle: 'dashed',
        width: '100%',
    },
});

export default (Platform.OS === 'web' ? Dash : require("react-native-dash").default);